export const SIGNUP_URL = "https://southendcapital.com/?rp=RP015744";
export const FLYER_URL = "/hope-cds-flyer-signup-link.png";
export const BUTTON_URL = "/signup-button.png";
export const IG_URL = "/hope-cds-flyer-1080x1350.jpg";
export const STORY_URL = "/hope-cds-flyer-1080x1920.jpg";
export const TRACK_URL = window.location.hostname === "localhost"
  ? `${process.env.REACT_APP_BACKEND_URL}/api/track/click`
  : "/api/track/click";

export const CAPTION = `💰 YOUR BUSINESS HAS A VISION — NOW LET'S TALK FUNDING! 💰

Ready to expand, invest in commercial real estate, purchase equipment, or take your company to the NEXT LEVEL?

✅ No-Doc Business Lines of Credit & Commercial Real Estate Funding
✅ Flexible business funding options
✅ Financing opportunities to support business growth
✅ Take the next step toward your financial goals

👑 FUND YOUR BUSINESS. GROW YOUR LEGACY!
💥 Stop dreaming about your next business move — start exploring your funding options!

🔗 Sign up today: https://southendcapital.com/?rp=RP015744
📩 Inbox me — serious-minded inquiries only!

🔥 Let's talk business. Let's talk funding. Let's talk building wealth!

#BusinessFunding #BusinessCredit #CommercialRealEstate #NoDoc #SmallBusinessFunding #BusinessLinesOfCredit #FundingSpecialist #BuildYourLegacy #Entrepreneur #FundYourBusiness #HopeCDS`;

export const HOTSPOTS = [
  {
    id: "hotspot-signup-button",
    label: "Sign Up Today",
    style: { left: "22.5%", top: "72.2%", width: "74.5%", height: "8%" },
  },
  {
    id: "hotspot-qr-code",
    label: "Scan QR code to sign up",
    style: { left: "68.9%", top: "89%", width: "20.8%", height: "10.8%" },
  },
];
